/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useState } from 'react';
import { expVal } from '@atlassian/jira-feature-experiments';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import type { Plugin } from '@atlassian/react-resource-router';
import {
	createResourcesPlugin,
	type ResourceStoreContext,
	type ResourceStoreData,
} from '@atlassian/react-resource-router/src/resources';
import { createEntryPointsPlugin } from '@jira/platform__entry-points-plugin/src/services/create-plugin/index.tsx';
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';
import { setCapability } from '@jira/platform__observability-capabilities/src/services/active-capability-tracker/index.tsx';
import { createCapabilityHeaderPlugin } from '../services/create-capability-header-plugin/createCapabilityHeaderPlugin.tsx';

export const usePlugins = ({
	resourceContext,
	resourceData,
}: {
	resourceContext?: ResourceStoreContext | undefined;
	resourceData?: ResourceStoreData | undefined;
}): Plugin[] => {
	const tenantContext = useTenantContext();
	// make sure "plugins" are created only once, ignore prop change/rerender
	const [pluginsWithOverride] = useState(() => {
		const jiraPlugins: Plugin[] = [];
		if (expVal('jpo-42550-improve-capability-tracking', 'isEnabled', false)) {
			jiraPlugins.push(createCapabilityHeaderPlugin(setCapability));
		}

		const resourcesPlugin = createResourcesPlugin({
			context: resourceContext,
			resourceData,
		});

		jiraPlugins.push(resourcesPlugin);

		jiraPlugins.push(
			createEntryPointsPlugin({
				environment: getRelayEnvironment(),
				entryPointParams: { tenantContext },
			}),
		);

		return jiraPlugins;
	});

	return pluginsWithOverride;
};
